(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[82324],{

/***/ 47229:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/market/appDetailMenu/appHeader",
      function () {
        return __webpack_require__(21520);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 37276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ initKakao; },
/* harmony export */   "L": function() { return /* binding */ shareKakao; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);


var initKakao = function() {
    if (window.Kakao) {
        var kakao = window.Kakao;
        if (!kakao.isInitialized()) {
            kakao.init("37d6f07b8ece67b826f25e89654bf4e1");
        }
    }
};
var shareKakao = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(linkUrl, title, description) {
        var basicTitle, basicDescription, image, sendTitle, sendDescription, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    basicTitle = "인공지능 서비스 마켓 아이소";
                    basicDescription = "이미지, 데이터 분석 등 다양한 아이소 앱을 사용해보세요.";
                    image = "https://firebasestorage.googleapis.com/v0/b/aiso-api.appspot.com/o/apps%2Fpreview%2Faiso_logo.jpg?alt=media&token=e6014be6-b135-4fdf-bac2-9e86295ffac5";
                    sendTitle = title ? title : basicTitle;
                    sendDescription = description ? description : basicDescription;
                    _tmp = {};
                    /* sendDefault */ return [
                        4,
                        window.Kakao.Link.sendDefault((_tmp.objectType = "feed", _tmp.content = {
                            title: sendTitle,
                            description: sendDescription,
                            imageUrl: image,
                            imageWidth: 1500,
                            imageHeight: 600,
                            link: {
                                mobileWebUrl: linkUrl,
                                webUrl: linkUrl
                            }
                        }, _tmp.buttons = [
                            {
                                title: "아이소로 이동하기",
                                link: {
                                    mobileWebUrl: linkUrl,
                                    webUrl: linkUrl
                                }
                            }, 
                        ], _tmp))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function shareKakao(linkUrl, title, description) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [34619,52387,94924,33426,76328,85388,868,67872,46383,21520,49774,92888,40179], function() { return __webpack_exec__(47229); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);